import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_OG_IMAGE, absoluteUrl } from '../constants/site';

/**
 * 페이지별 SEO 메타 태그 (title/description/canonical/OG/Twitter/JSON-LD)
 * - path: 사이트 루트 기준 경로 (canonical, og:url 생성에 사용)
 * - jsonLd: JSON-LD 객체 배열
 */
const Seo = ({
  title,
  description,
  path = '/',
  ogTitle = title,
  ogDescription = description,
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  jsonLd = [],
  children,
}) => {
  const url = absoluteUrl(path);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      <meta name="twitter:image" content={image} />

      {jsonLd.map((data, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(data)}</script>
      ))}
      {children}
    </Helmet>
  );
};

export default Seo;
